/** 首页文案：面向普通 Android 用户的介绍与帮助；Hero + 正文需 ≥1500 英文词（飞书）
 *
 * 正文内链（首页视为一篇长文）：
 * - 锚文本口语化，融入句子；约 4–6 条，同一 href 只出现一次（不含 Hero 按钮与 troubleCards）
 */
export const homeMeta = {
	title: 'GB WhatsApp Pro APK Download for Android – Latest v18.80',
	description:
		'Download GB WhatsApp Pro APK for Android. Learn features, installation, updates, safety risks, and troubleshooting on an independent help site—not official WhatsApp.',
	keywords:
		'gb whatsapp pro apk, gb whatsapp pro download, gb whatsapp pro android, gb whatsapp pro features',
}

export const appDetails = [
	{ label: 'App Name', value: 'GB WhatsApp Pro' },
	{ label: 'Latest Version', value: 'v18.80' },
	{ label: 'APK Size', value: '~191.3 MB' },
	{ label: 'Android Compatibility', value: 'Android 5.0 or later' },
	{ label: 'Package Information', value: 'Check Settings → App info after you install (wording varies by version)' },
	{ label: 'Last Updated', value: 'Sep 2026' },
]

export const hero = {
	kicker: 'Latest for Android · v18.80',
	h1: 'GB WhatsApp Pro APK Download for Android',
	intro:
		'GB WhatsApp Pro is an alternate WhatsApp-style app for Android with extra privacy and look-and-feel options. This page walks you through what it is, how to get it on your phone, and what to watch out for. You download the file yourself—it is not in the Google Play Store, and WhatsApp / Meta do not support it.',
	disclaimer:
		'GB WhatsApp Pro is an unofficial modified app. It is not published by WhatsApp LLC or Meta Platforms, Inc. GBWhatPro.org provides install and troubleshooting guides only—not official support.',
}

/** Hero 信任条（与 App Details 一致） */
export const heroTrust = [
	{ label: 'Latest version', value: 'v18.80' },
	{ label: 'APK size', value: '~191.3 MB' },
	{ label: 'Android', value: '5.0 or later' },
	{ label: 'Last updated', value: 'Sep 2026' },
]

export const featureCategoryCards = [
	{
		icon: '🔒',
		label: 'Privacy Features',
		href: '/features/privacy-features/',
		desc: 'Hide when you are online, delay read ticks, and similar options—if your version includes them.',
	},
	{
		icon: '🎨',
		label: 'Customization',
		href: '/features/customization/',
		desc: 'Change colors, fonts, and chat themes. Menus differ between releases, so follow the guide that matches your screen.',
	},
	{
		icon: '💬',
		label: 'Chat Features',
		href: '/features/chat-features/',
		desc: 'Schedule messages, lock chats, and other extras beyond the official app.',
	},
	{
		icon: '📁',
		label: 'Media Sharing',
		href: '/features/media-sharing/',
		desc: 'Send larger files or save status clips when your build allows it.',
	},
]

export const comparisonTable = {
	headers: ['Topic', 'GB WhatsApp Pro', 'Official WhatsApp'],
	rows: [
		['Where you get it', 'Download file from the web, then install manually', 'Google Play or other official stores'],
		['Look and themes', 'More themes and layout options in many versions', 'Fewer built-in theme choices'],
		['Privacy options', 'Extra switches in some versions', 'Standard WhatsApp privacy settings'],
		['Updates', 'You download and install new files yourself', 'Updates through the store, usually automatic'],
		['Help if something breaks', 'Community guides; no WhatsApp support line', 'Official WhatsApp / Meta support'],
		['Account problems', 'Some people report bans or warnings with mods', 'Normal path for most personal accounts'],
	],
}

export const installSteps = [
	'Get the file from our <a href="/download/">download page</a> (or the same source you trust). On Wi‑Fi, wait until the download finishes—about 191.3 MB for v18.80.',
	'If you already have chats you care about, back them up inside the app before you install over an older copy.',
	'Open the downloaded file. When Android asks, allow your browser or Files app to install apps—it will name the app that needs permission.',
	'Tap Install and wait until you see Done.',
	'Open GB WhatsApp Pro, enter your phone number, enter the code from SMS or the phone call, and restore chats if the app offers that step.',
]

export const updateSteps = [
	'In the app, open Settings and note the version you are on today.',
	'Run a chat backup and wait until it finishes.',
	'Download the newer file from the same place you got the last one. Our <a href="/update/">update guide</a> explains how versions are labeled.',
	'Install on top of the app you already have when Android offers Update.',
	'If you see “App not installed,” stop and read the <a href="/update/update-failed/">update failed</a> help before you delete anything.',
]

export const troubleCards = [
	{
		title: 'App not installing',
		text: 'Full storage, a bad download, or a blocked install message.',
		href: '/help/not-installing/',
	},
	{
		title: 'App keeps crashing',
		text: 'Often right after installing the wrong file or an interrupted download.',
		href: '/help/keeps-crashing/',
	},
	{
		title: 'Messages not sending',
		text: 'Stuck on one grey tick, or nothing goes out at all.',
		href: '/help/messages-not-sending/',
	},
	{
		title: 'Notifications not working',
		text: 'Alerts arrive late or not at all.',
		href: '/help/notifications-not-working/',
	},
	{
		title: 'Photos and videos not downloading',
		text: 'Media stays loading or never saves to the phone.',
		href: '/help/photos-videos-not-downloading/',
	},
	{
		title: 'Update errors',
		text: 'The new file will not install over the old app.',
		href: '/update/update-failed/',
	},
]

export const homeFaqItems = [
	{
		question: 'Can I use GB WhatsApp Pro on iPhone?',
		answer:
			'No. This app is for Android phones only. Sites that sell or share “GB WhatsApp for iPhone” files are usually not trustworthy.',
	},
	{
		question: 'Can I run GB WhatsApp Pro and official WhatsApp together?',
		answer:
			'Sometimes two icons can sit on the same phone, but one phone number usually works in one app at a time. Read the installation section on keeping both apps before you try it.',
	},
	{
		question: 'How do I know which version I have installed?',
		answer:
			'Open Settings inside the app and look for App info or Help—the label differs by build. Compare what you see with the version shown on our download page.',
	},
	{
		question: 'Why did my verification SMS not arrive?',
		answer:
			'Wrong country code, weak signal, roaming, or tapping “send code” too many times can delay SMS. Wait for the timer, then try again. Never give your code to someone who messages you claiming to be support.',
	},
	{
		question: 'Will using GB WhatsApp Pro guarantee that my account will not be restricted?',
		answer:
			'No. WhatsApp can limit or block accounts that use unofficial apps. Ads that promise “100% anti-ban” are not guarantees.',
	},
	{
		question: 'What should I do if WhatsApp says I must use the official app?',
		answer:
			'That message comes from WhatsApp, not from this website. Save your chats if you still can, switch to official WhatsApp from the store, and restore if you have a backup.',
	},
	{
		question: 'Does GBWhatPro.org provide customer support for my account?',
		answer:
			'We only publish guides. We cannot unlock your account, send SMS codes, or fix bans. Use our contact page if you need to reach the site owners about the website itself.',
	},
]

export const homeFaqSection = {
	h2: 'Frequently Asked Questions',
	lead: 'A few quick answers. More questions and longer explanations live on the full FAQ page.',
}

export const homeSections = [
	{
		h2: 'Quick App Information',
		paragraphs: [
			'These numbers describe the v18.80 build on our download page. Match them on your phone before you install so you know you have the right release.',
		],
		detailsTable: true,
	},
	{
		h2: 'What Is GB WhatsApp Pro?',
		paragraphs: [
			'GB WhatsApp Pro looks and works like WhatsApp, but it is a modified copy you install from a file—not from the Play Store. Different teams publish these files, so menus and options can change from one release to the next.',
			'Official WhatsApp comes from Meta, updates on its own, and follows the rules WhatsApp sets for every account. GB WhatsApp Pro is outside that system. You choose when to download updates, and WhatsApp may treat your account differently if you use a mod.',
			'People often look for it when they want more control over how the app looks, who can see when they are online, or how messages behave. That does not mean the app is official, approved, or risk-free.',
			'Meta did not build GB WhatsApp Pro and does not support it. If something goes wrong with your number, you need to follow WhatsApp’s own instructions—not a help desk from this site.',
		],
	},
	{
		h2: 'What Can You Do With GB WhatsApp Pro?',
		paragraphs: [
			'Not every version includes every option below. Open the app on your phone and check Settings before you assume a feature is there.',
		],
		useCaseBlocks: [
			{
				h3: 'Privacy settings',
				text: 'You might hide your “online” status so contacts do not see you as soon as you open the app, or delay the blue ticks that show you read a message. Useful when you want more quiet time—but friends may still notice odd behavior, and WhatsApp can still act on its own rules.',
			},
			{
				h3: 'Interface customization',
				text: 'Change chat colors, fonts, or full themes so chats feel more personal. If a tutorial screenshot does not match your menus, use our customization guide and compare step by step with what you see on screen.',
			},
			{
				h3: 'Chat management',
				text: 'Some builds let you schedule a message for later, lock a chat behind a PIN, or pause alerts inside the app only. Try one new setting at a time with a friend you trust so you know what changed.',
			},
			{
				h3: 'Media-sharing options',
				text: 'You may be able to send bigger videos or save someone’s status to your gallery. It still depends on your Wi‑Fi, free space, and whether the other person’s phone can receive the file.',
			},
			{
				h3: 'Additional messaging controls',
				text: 'Auto-reply while you are busy, extra mute options, or shortcuts can show up in some versions. They are conveniences—not a replacement for normal carrier service or official WhatsApp help.',
			},
		],
	},
	{
		h2: 'GB WhatsApp Pro Features',
		paragraphs: [
			'Most people search in four areas: privacy, looks, chat tools, and media. Pick a topic below when you want menu-by-menu help instead of a general overview.',
			'Every release moves menus around. If a switch is missing, your build may not include it yet—or it may sit under a different name in Settings.',
		],
		featureCategories: true,
	},
	{
		h2: 'GB WhatsApp Pro vs Official WhatsApp',
		paragraphs: [
			'Use this table to decide which app fits your number. It is not a contest—official WhatsApp is the supported choice if you need store updates and company-backed help.',
		],
		tableKey: 'comparison',
	},
	{
		h2: 'How to Download and Install',
		paragraphs: [
			'You install GB WhatsApp Pro like any other app file from the web: download, allow the install when Android asks, then sign in with your number. Step-by-step photos and phone-brand tips are in our <a href="/installation/">installation hub</a>.',
			'Use Wi‑Fi for a large download and keep the phone awake until the file is fully saved. If menus on Samsung, Xiaomi, or other brands look different, the <a href="/installation/android/">Android install notes</a> walk through common screens.',
			'Using the same SIM in official WhatsApp already? Decide whether you will move your chats to GB WhatsApp Pro or keep both apps—using one number in two places without a plan causes confusion fast.',
		],
		steps: installSteps,
	},
	{
		h2: 'How to Update GB WhatsApp Pro',
		paragraphs: [
			'There is no automatic update from the Play Store. When a new v18.x file is out, you download it and install over the app you already have—after you back up chats.',
			'If the phone says the app expired or an update is required, you usually need a current file from a trusted source, not a random link in a comment thread.',
		],
		steps: updateSteps,
	},
	{
		h2: 'Is GB WhatsApp Pro Safe?',
		paragraphs: [
			'Any WhatsApp mod is “use at your own risk.” You are installing software from outside WhatsApp’s official channels. Files can be altered, your chats sit in an app Meta does not audit, and WhatsApp may warn or restrict your account.',
			'Stick to sources you can check against our download page, skip paid “unban” services, and be extra careful if this phone number is used for bank texts or work logins. More detail lives on our <a href="/safety/">safety pages</a>.',
		],
		list: [
			'Skip files shared in random group chats or comment threads unless you can verify them.',
			'If the app shows a countdown or tells you to switch to official WhatsApp, back up while it still opens.',
			'Review which permissions the app has in Android Settings and turn off anything you did not mean to allow.',
		],
		safetyPanel: true,
	},
	{
		h2: 'Common GB WhatsApp Problems',
		paragraphs: [
			'Pick the card that matches what you see. Clearing all app data as a first step can wipe chats when you have no backup.',
			'If one message will not send, try turning airplane mode off and on and make sure the phone is not in a strict battery-saving mode. For anything that persists, open the linked guide and work through its checklist.',
		],
		troubleKey: 'cards',
	},
	{
		h2: 'Who May Find GB WhatsApp Useful?',
		paragraphs: [
			'You might read about GB WhatsApp Pro if you like tweaking how chats look, want a few extra privacy switches, or do not mind checking for updates yourself.',
			'It is a weak fit for work accounts, health care threads, or any number that receives bank or login codes. Official WhatsApp is the safer default when mistakes are costly.',
			'If you install anyway, treat GBWhatPro.org as a neighbor helping you read instructions—not as WhatsApp support.',
		],
	},
]

export const homeFinalSection = {
	h2: 'Final Download Section',
	paragraphs: [
		'Ready to try it? Use the button below or the download page on Wi‑Fi, then follow the install steps above. Back up first if you are replacing a copy you already use.',
		'Remember: this is unofficial software. We cannot restore a banned account or send you a verification code. When you need line-by-line help, use the installation guide linked below.',
	],
}
